import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    sidebarCollapsed: false
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    userType: state => state.userInfo.userType,
    username: state => state.userInfo.username,
    roleCode: state => state.userInfo.roleCode,
    sidebarCollapsed: state => state.sidebarCollapsed
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      try {
        localStorage.setItem('token', token)
      } catch (e) {
        console.error('localStorage setItem failed:', e)
      }
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      try {
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
      } catch (e) {
        console.error('localStorage setItem failed:', e)
      }
    },
    CLEAR_TOKEN(state) {
      state.token = ''
      state.userInfo = {}
      try {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
      } catch (e) {
        console.error('localStorage removeItem failed:', e)
      }
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    }
  },
  actions: {
    login({commit}, {token, ...userInfo}) {
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
    },
    logout({commit}) {
      commit('CLEAR_TOKEN')
    },
    toggleSidebar({commit}) {
      commit('TOGGLE_SIDEBAR')
    }
  }
})

